import { create } from 'zustand';

export type AuthUser = {
  id: string;
  email: string;
  fullName: string | null;
  roles: string[];
  perms: string[];
  totpEnabled: boolean;
  // Set server-side after an admin generates a temp password. While true the
  // portal forces the change-password screen; cleared once it's rotated.
  mustChangePassword: boolean;
};

type AuthState = {
  token: string | null;
  user: AuthUser | null;
  setSession: (token: string, user: AuthUser) => void;
  setMustChangePassword: (value: boolean) => void;
  clear: () => void;
};

export const useAuthStore = create<AuthState>((set) => ({
  token: null,
  user: null,
  setSession: (token, user) => set({ token, user }),
  setMustChangePassword: (value) =>
    set((s) => (s.user ? { user: { ...s.user, mustChangePassword: value } } : s)),
  clear: () => set({ token: null, user: null }),
}));
